/**
 * Karten-Link für einen Termin-Ort (ADR-090): native iOS → Apple Karten
 * (maps://), native Android → geo:-Intent (Karten-App nach Wahl), Web →
 * Google Maps. Reine Funktion; die Plattform kommt von Capacitor.
 */
export function mapsUrl(query: string): string {
  const q = encodeURIComponent(query.trim())
  const platform = typeof window !== 'undefined' ? window.Capacitor?.getPlatform?.() : undefined
  if (platform === 'ios') return `maps://?q=${q}`
  if (platform === 'android') return `geo:0,0?q=${q}`
  return `https://www.google.com/maps/search/?api=1&query=${q}`
}
